import React, { Component } from 'react'
import { observer } from 'mobx-react'
import DocumentTitle from 'react-document-title'

import ProjectsPipelineFilterPanel from './ProjectsPipelineFilterPanel'
import ProjectsPipelineView from './ProjectsPipelineView'

class ProjectsPipeline extends Component {
  render () {
    return (
      <DocumentTitle title='Projects pipeline | Atheneum Partners'>
        <div className='expert-search'>
          <ProjectsPipelineFilterPanel />
          <ProjectsPipelineView />
        </div>
      </DocumentTitle>
    )
  }
}

export default observer(ProjectsPipeline)
